module.exports = __webpack_public_path__ + "assets/img/targeting-lot.36d58dd0.svg";